import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, AfterContentInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Intake, Patient, PatientPlanTypes, ScheduleResponse, PatientScheduledVisits, LabworkRequestModel } from '../models';
import { Api, Session } from '../services/index';
import { Observable } from 'rxjs/Observable';
import { Toolbar } from '@syncfusion/ej2-navigations';
import { Browser } from '@syncfusion/ej2-base';
import * as Globalize from 'globalize';




@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.html', 
	styleUrls: ['./dashboard.css'],
})

export class DashboardComponent implements OnInit {
	activeExam: Intake;
	avatar: string = '../../assets/images/ico-profile.png';
	loading = false;
	patient: Patient;
	policyType: number = 1;
	pasPlan = false;
	ucPlan = false;
	bhPlan = false;
	psiPlan = false;
	psfPlan = false;
	isBrowserSupported: boolean;
	patientPlanTypes: Array<PatientPlanTypes>;
	isPatientTherapyPlan: boolean;
	isPatientPhyscPlan: boolean;
	upcomingVisits: Array<PatientScheduledVisits>;
	labworkRequestsActive: Array<LabworkRequestModel>;
	isNewMessagesAvailable: boolean = false;
	nextAppointment: PatientScheduledVisits;

	public isRequesting: boolean;

	constructor(private api: Api,
		private route: ActivatedRoute,
		private changeDetectorRef: ChangeDetectorRef,
		private router: Router,
		private service: NotificationsService,
		private session: Session) {
		this.patientPlanTypes = new Array<PatientPlanTypes>();
		this.upcomingVisits = new Array<PatientScheduledVisits>();
		this.isPatientPhyscPlan = false;
		this.isPatientTherapyPlan = false;
		this.session.intakeLob = '';
		this.session.intakeBhType = '';
		this.labworkRequestsActive = new Array<LabworkRequestModel>();

	}

	ngOnInit() {
		this.loading = true;
		this.isRequesting = true;
		this.activeExam = null;
	
		let _getPatientScheduledIntakes = this.api.getPatientScheduledIntakes(this.session.patientId).map(result => {
			// Only show schedules for patient user (who is currently logged in via the PHS Patient App) has a BH/THI Plan
			this.upcomingVisits  = result.filter( visit => visit.serviceLine === 'THI');
			if (this.upcomingVisits && this.upcomingVisits.length > 0) {
				this.nextAppointment = this.upcomingVisits[0];
				
			}
		});

		let _getPatientPlanTypes = this.api.getPatientPlanTypes(this.session.patientId).map(planTypeResults => {
			this.patientPlanTypes = planTypeResults;
		});

		let _getPatient = this.api.getMember(this.session.patientId).map(patientResults => {
			this.patient = patientResults;
		}, error => {
			this.patient = null;
		});

		let _getPatientPolicyType = this.api.getPatientPolicyType(this.session.patientId).map(policyTypeResult => {
			this.policyType = policyTypeResult;			
		});

		let _getActiveIntake = this.api.getActiveIntake(this.session.patientId).map(examResult => {
			this.activeExam = examResult;
		});

		let _getLabworkRequestsByUserIdActive = this.api.getLabworkRequestsByUserId(this.session.patientId, 'active').map(labresults => {
			this.labworkRequestsActive = labresults;
		});

		Observable.forkJoin([_getPatientScheduledIntakes,
			_getPatient,
			_getPatientPolicyType,
			_getPatientPlanTypes,
			_getActiveIntake,
			_getLabworkRequestsByUserIdActive
		]).subscribe(results => {
			console.log('Policy Type:', this.policyType);
			console.log('Patient Id:', this.patient.userId);

			if(this.labworkRequestsActive.length > 0){
				this.isNewMessagesAvailable = true;

			}
			if (!this.changeDetectorRef['destroyed']) {
				this.changeDetectorRef.detectChanges();
			}

			if(!this.policyType){
				this.patient.policyType = 0;
			}else{
				this.patient.policyType = this.policyType;
			}

			if(this.patient){
				this.initializePlans(this.patient.userId);
	
				if (this.patient.avatar) {
					this.avatar = this.session.environment.settings.patientAvatarBucket + this.patient.avatar;
				} else if (this.patient.profile.gender.toUpperCase() == 'F') {
					this.avatar = '../../assets/images/patient-avatar-female.png';
				} else {
					this.avatar = '../../assets/images/patient-avatar-male.png';
				}
	
	
			} 
	
			if(this.patientPlanTypes.length > 0){
				this.patientPlanTypes.forEach(plans => {
					switch (plans.planTypeCode) {
						case 'PSI':
							this.psiPlan = true;
							this.isPatientPhyscPlan = true;
							break;
						case 'THI':
							this.bhPlan = true;
							this.isPatientTherapyPlan = true;
							break;
						case 'BH':
							this.bhPlan = true;
							break;
					}
				});
			}


			this.loading = false;
			this.isRequesting = false;
		

		}, (error) => {
			console.log(error);
			this.loading = false;
			this.isRequesting = false;
		});




			


	}

	ngAfterContentInit() {
		console.log('ngAfterContentInit');
		let ua = window.navigator.userAgent;
		let msie = ua.indexOf('MSIE ');
		let trident = ua.indexOf('Trident/');
		if(trident > -1 || msie> -1){
			this.isBrowserSupported = false;

		} else {
			this.isBrowserSupported = true;
		}

		console.log('this.isBrowserSupported', this.isBrowserSupported);


	}

	
	initializePlans(userId: number) {

		this.api.getAllPatientPlans(userId).subscribe(result => {

			if (result == null || result.length === 0) {
				console.log('no plans.');
				return;
			}

			result.forEach(policy => {
				if (policy == null) {
					console.log('policy is null:', policy);
					return;
				}

				console.log('policy.PlanTypeCode:', policy.planTypeCode);
				switch (policy.planTypeCode) {
					case 'UC':
						this.ucPlan = true;
						break;
					case 'BH':
						this.bhPlan = true;
						break;
					case 'PSI':
						this.psiPlan = true;
						break;
					case 'PSF':

						this.psfPlan = true;
						break;
					case 'PAS':
						this.pasPlan = true;
						console.log('this.pasPlan:', this.pasPlan);
						break;
				}
			});
		});
	}

	viewActiveExamTapped() {
		this.router.navigate(['/thankyou/' + this.activeExam.intakeId]);
	}
	viewActiveVisitTapped(intakeId){
		this.router.navigate(['/thankyou/' + intakeId]);
	}
	openBrowserDownload() {
		console.log('openBrowserDownload');
		let url = 'https://www.google.com/chrome/browser/desktop/index.html'
		let newWindow = window.open("about:blank", "_blank");
		newWindow.opener = null;
		newWindow.location.href = url;
	}

	requestExam() {
		this.session.intakeLob = 'UC'
		this.session.intakeBhType = '';
		 this.router.navigateByUrl('/exam-request-care-today');
	}

	requestTalkTherapy() {
		this.session.intakeLob = 'BH'
		this.session.intakeBhType = 'THI';
		this.router.navigateByUrl('/exam-request-care-today');
	}

	gotoLearnMore(planType: string) {
		this.session.intakeLob = 'BH';
		this.session.intakeBhType = 'THI';
		if (planType === 'THI') {
			this.router.navigate(['/dashboard-medical/2']);
		} else {
			this.router.navigate(['/dashboard-medical/1']);
		}
		
	}

	gotoProfile(){
		this.router.navigateByUrl('/dashboard-my-profile');
	
	}

	gotoHistory(){
		this.router.navigateByUrl('/dashboard-exam-history');
	
	}
	goToMyDocuments(){
		this.router.navigate(['/mydocuments']);
	}

	goToMyAppointments() {
		this.router.navigate(['/my-appointments']);
	}

	goToAppointment() {
		if (this.nextAppointment) {
			this.viewActiveVisitTapped(this.nextAppointment.intakeId);
		} else {
			this.router.navigate(['/exam-request']);
		}	
	}
}
